module.exports = __webpack_public_path__ + "img/ARRASTAR2.9872b711.svg";